// react
import React, { PropsWithChildren } from "react";

// components
import { Spinner } from "@performyard/py-components";

// config
import appConfig from "../../app-config";
// styles
import css from "./Spinner.module.scss";

interface ComponentLoaderProps {
	/**
	 * The size of the PerformYard logo in pixels.
	 * @default 40
	 */
	logoSize?: number;
	/**
	 * Whether or not to show a curtain behind the loader in order to blank
	 * out the page behind the loader.
	 */
	showCurtain?: boolean;
}

/**
 * A component loader that shows a spinner and the PerformYard logo as a full
 * page overlay. This is useful for when a component is loading and you want to
 * show the user that something is happening.
 * @deprecated Use `ComponentLoader` from `@performyard/py-components` instead.
 */
const ComponentLoader = (props: PropsWithChildren<ComponentLoaderProps>) => {
	const { logoSize = 40, showCurtain } = props;

	const curtainStyle = {
		position: "fixed",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		backgroundColor: "rgba(255, 255, 255, 0.5)",
		zIndex: 100,
	} satisfies React.CSSProperties;

	const logoStyle = {
		width: logoSize,
	};

	return (
		<React.Fragment>
			{showCurtain ? <div style={curtainStyle} /> : null}
			<div className={css.loaderBg} style={{ display: "flex" }}>
				<img style={logoStyle} src={`${appConfig.mediaCDN}static/img/py-logo/py-logo-solo.png`} alt="" />
				<div className="top-[10px]">
					<Spinner size={20} data-testid="spinner" />
				</div>
			</div>
		</React.Fragment>
	);
};

/** @deprecated Use `ComponentLoader` from `@performyard/py-components` instead. */
export default ComponentLoader;
